import PublicOrgService from '../apiServices/publicOrgService'

/**
 * The public org hook for public org details
 */
export const usePublicOrg = () => {
  /**
   * Get public org Details
   */
  const getPublicOrgData = async () => {
    return PublicOrgService.getPublicOrgDetails();
  }

  return {
    getPublicOrgData
  }
}